import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { setTariff } from 'services/stay-service';
import { Button, themes } from 'libs/ui';
import { SetTariff } from './forms/set-tariff';

export const SetTariffAction = ({ id, parkingId, refresh, is_active, tariff_id }) => {
  const { t } = useTranslation();

  const [show, setShow] = useState(false);

  /**
   * show form
   */
  const showForm = () => {
    setShow(true);
  };

  /**
   * hide form
   */
  const hideForm = () => {
    setShow(false);
  };

  /**
   * change mean status
   */
  const action = async ({ tariff_id }) => {
    const data = {
      stay_id: id,
      tariff_id: tariff_id,
    };

    await setTariff(data);
    refresh();
  };

  // check
  if (!is_active || !user.haveRight('tariff.list') || !user.haveRight('tariff.replace')) {
    return null;
  }

  return (
    <>
      <Button theme={themes.gray} fontSize="16px" onClick={showForm}>
        <i className="fa fa-ticket"></i>
        {t('buttons.Сменить тариф')}
      </Button>
      {show && <SetTariff parkingId={parkingId} tariffId={tariff_id} close={hideForm} action={action} />}
    </>
  );
};
